'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { WebSunsetGate } from '@/components/web-sunset-gate';
import LoginClient from './login-client';
export default function LoginExperience(t0) {
  const $ = _c(2);
  const {
    webSunsetGateEnabled
  } = t0;
  const [showLoginForm, setShowLoginForm] = useState(!webSunsetGateEnabled);
  if (!showLoginForm) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <WebSunsetGate onAccess={() => setShowLoginForm(true)} />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LoginClient />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}